import CategoryListContainer from '../../../../Componant/Application/Ecommerce/master/CategoryListContainer'

const CategoryList = () => {
  return (
    <div className='page-body'>
      <CategoryListContainer />
    </div>
  )
}

export default CategoryList